import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface
} from "class-validator";
import { isValid } from 'date-fns';

@ValidatorConstraint({ name: 'IsAfter' })
export class IsAfterValidator implements ValidatorConstraintInterface {
	validate(date: any, args: ValidationArguments) {
		const relatedFieldOrNow = args.constraints[0] as string;
		let relatedDate: any;

		if (relatedFieldOrNow === 'now') {
			relatedDate = new Date();
		} else {
			relatedDate = (args.object as Record<string, any>)[relatedFieldOrNow];
		}

		if (!isValid(new Date(relatedDate)) || !isValid(new Date(date))) {
			return false;
		}

		return new Date(relatedDate).getTime() < new Date(date).getTime();
	}

	defaultMessage(args: ValidationArguments) {
		return `Date ${args.property} can not before now.`;
	}
}

export const IsAfter = (
	relatedFieldOrNow: string,
	validationOptions?: ValidationOptions
) => (object: Record<never, never>, propertyName: string) => {
	registerDecorator({
		name: 'IsAfter',
		target: object.constructor,
		propertyName,
		constraints: [relatedFieldOrNow],
		options: validationOptions,
		validator: IsAfterValidator,
	});
};
